import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAuthPayload } from "../../admin/navigation/adminNavigation";

const Protected = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();
  const user = getAuthPayload(authState);

  if (authState?.isAuthenticated && user?.accessToken) {
    return children;
  }

  return (
    <Navigate
      to="/login"
      replace
      state={{ from: `${location.pathname}${location.search}${location.hash}` }}
    />
  );
};

export default Protected;
